module.exports = __webpack_public_path__ + "static/Tuktuki-04f0919cf1b18328cebd79477a2f2eba.png";